(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-gracias"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-ls-confirmation]').forEach((root) => {
      if (root.dataset.initialized || window.Shopify?.designMode) return;
      root.dataset.initialized = 'true';
      const link = root.querySelector('[data-instagram]');
      const countdown = root.querySelector('[data-countdown]');
      const counter = countdown?.querySelector('[data-seconds]');
      const unit = root.querySelector('[data-unit]');
      const status = root.querySelector('[data-status]');
      if (!link || !countdown || !counter || !unit || !status) return;
      let destination;
      try {
        destination = new URL(link.href);
        if (destination.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(destination.hostname)) return;
      } catch { return; }
      let remaining = Math.max(3, Math.min(10, Number.parseInt(root.dataset.seconds, 10) || 5));
      counter.textContent = String(remaining);
      countdown.hidden = false;
      let interval = window.setInterval(() => {
        if (document.visibilityState === 'hidden') return;
        remaining -= 1;
        counter.textContent = String(remaining);
        unit.textContent = remaining === 1 ? unit.dataset.single : unit.dataset.plural;
        if (remaining > 0) return;
        window.clearInterval(interval);
        countdown.hidden = true;
        status.textContent = root.dataset.opening;
        window.location.assign(destination.href);
      }, 1000);
      link.addEventListener('click', () => window.clearInterval(interval), { once: true });
      window.addEventListener('pagehide', () => window.clearInterval(interval), { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
